import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ContentChild, Directive, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Directive({
  selector: '[card-header]',
  standalone: true,
})
export class MatrixCardHeaderDirective {}

@Component({
  selector: 'app-matrix-card',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './matrix-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatrixCardComponent {
  /**
   * Controls the decorative icon placement.
   * - `top-right`: current default placement (absolute, top-right).
   * - `bottom-center`: centered horizontally at the bottom of the card.
   */
  @Input() iconPosition: 'top-right' | 'bottom-center' = 'top-right';

  @Input() tightContentSpacing?: boolean = false;
  @Input() highlighted = false;
  @Input({ required: true }) title!: string;
  @Input() periodLabel?: string;
  @Input() iconUrl?: string;
  @Input() iconAlt?: string;
  /**
   * Optional in-app route. When provided, both the title and icon become clickable and route here.
   * Accepts the same shapes as Angular's RouterLink input.
   */
  @Input() link?: string | readonly unknown[];

  @ContentChild(MatrixCardHeaderDirective)
  protected readonly cardHeader?: MatrixCardHeaderDirective;

  getTitleParts(): { firstWord: string; rest: string } {
    const words = this.title.trim().split(/\s+/);
    if (words.length === 0) {
      return { firstWord: '', rest: '' };
    }
    if (words.length === 1) {
      return { firstWord: words[0], rest: '' };
    }
    return {
      firstWord: words[0],
      rest: words.slice(1).join(' ')
    };
  }
}


